import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import ActionsSide from "../components/home/ActionsSide";
import VideoSide from "../components/home/VideoSide";
import Api from "../services/ApiService";
import QrSplashPage from "./QrSplashPage";
import ErrorPage from "./ErrorPage";

/**
 * Home Page 
 * 
 * This is first initial page, where users can login,
 * register (with/out QR) or reset password.
 * 
 * @url "/", "/qr/*"
 * 
 * @returns Page
 */
const HomePage = () => {

    const API = new Api(); // API
    const { qr } = useParams(); // Parameters if exist
    const location = useLocation(); // location url
    const view = location.pathname === "/willkommen" ? "register" : "login"; // views of action side
    const [videoDisplay, setVideoDisplay] = useState(require('../hero.mp4')); // video side video

    // if qr paramenter exist get qr info
    const { data, error, isLoading } = useQuery(['QR_INFO', qr], () => API.qr_info(qr), {
        enabled: !!qr,
        staleTime: Infinity
    });


    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0);
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
        }, 100);
    }, [])


    // function to show promo video
    const showInfoVideo = () => {
        setVideoDisplay(require("../noQrPromo.mp4"));
    }

    // GUI
    if (isLoading) return <QrSplashPage />;
    if (error) return <ErrorPage error={error} />;
    return (
        <div className="parent-container">
            <VideoSide videoDisplay={videoDisplay} showInfoVideo={showInfoVideo} />
            <ActionsSide defaultView={view} qrData={data ? data.data : undefined} showInfoVideo={showInfoVideo} />
        </div>

    )
}

export default HomePage;